module.exports = __webpack_public_path__ + "img/q3.6e1e847d.png";